export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "https://api.quazar.co.kr/api";
export const PUBLIC_WEB_BASE_URL =
  import.meta.env.VITE_PUBLIC_WEB_BASE_URL || "https://chat.quazar.co.kr";
export const ADMIN_WEB_BASE_URL =
  import.meta.env.VITE_ADMIN_WEB_BASE_URL || "https://adminweb.quazar.co.kr";
export const CERTIFICATE_WEB_BASE_URL =
  import.meta.env.VITE_CERTIFICATE_WEB_BASE_URL || "https://quazar.co.kr";
export const CERTIFICATE_PDF_BASE_URL =
  import.meta.env.VITE_CERTIFICATE_PDF_BASE_URL ||
  "https://objectstorage.ap-seoul-1.oraclecloud.com/n/cn6gmzmkljrp/b/quazar-real-cert/o";

export const LEGACY_S3_APPRAISAL_IMAGE_ORIGIN =
  "https://quazar-appraiser.s3.ap-northeast-2.amazonaws.com";
export const LEGACY_GCS_APPRAISAL_IMAGE_ORIGIN =
  "https://storage.googleapis.com/onda-aws/quazar-appraisal";
export const LEGACY_APPRAISAL_IMAGE_ORIGINS = [
  LEGACY_S3_APPRAISAL_IMAGE_ORIGIN,
  LEGACY_GCS_APPRAISAL_IMAGE_ORIGIN,
] as const;
export const APPRAISAL_IMAGE_CDN_ORIGIN =
  // "https://objectstorage.ap-seoul-1.oraclecloud.com/n/cn6gmzmkljrp/b/onda-aws/o/quazar-appraisal";
  "https://ik.imagekit.io/lu2uzbozj/onda-aws/quazar-appraisal";

export const replaceLegacyAppraisalImageOrigin = (url: string) => {
  const matchedOrigin = LEGACY_APPRAISAL_IMAGE_ORIGINS.find((origin) =>
      url.startsWith(origin),
  );
  return matchedOrigin
      ? url.replace(matchedOrigin, APPRAISAL_IMAGE_CDN_ORIGIN)
      : url;
};

export const buildApiUrl = (path: string) =>
  `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export const buildBackendApiUrl = (path: string) => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path
    .replace(/^\/quazar(?=\/|$)/, "")
    .replace(/^\/api(?=\/|$)/, "");

  return buildApiUrl(normalizedPath || "/");
};

export const buildImageRequestUrl = (appraisalNum?: string | number | null) =>
  `${PUBLIC_WEB_BASE_URL}/imgreq?stml=${appraisalNum ?? ""}`;

export const buildOpinionAdminDetailUrl = (id: string | number) =>
  `${ADMIN_WEB_BASE_URL}/opinion/show/${id}`;

export const buildPopinionAdminDetailUrl = (id: string | number) =>
  `${ADMIN_WEB_BASE_URL}/popinioncase/show/${id}`;

export const buildCertificateUrl = (
  serial?: string | number | null,
  version?: string | number | null,
) => {
  const certificateUrl = `${CERTIFICATE_WEB_BASE_URL}/certificates.html?ct=${serial ?? ""}`;

  if (version === undefined || version === null || version === "") {
    return certificateUrl;
  }

  return `${certificateUrl}&v=${version}`;
};

export const buildCertificatePdfUrl = (
  serial?: string | number | null,
  version?: string | number | null,
) => {
  const fileName = serial ? `${serial}.pdf` : "";
  const certificatePdfUrl = `${CERTIFICATE_PDF_BASE_URL}/${encodeURIComponent(fileName)}`;

  if (version === undefined || version === null || version === "") {
    return certificatePdfUrl;
  }

  return `${certificatePdfUrl}?v=${version}`;
};

export const OPINION_TYPE = [
  { label: "기업", value: "company" },
  { label: "개인", value: "person" },
];
export const APPRAISAL_STATUS = [
  { label: "감정 신청", value: 1 },
  { label: "감정 진행중", value: 2 },
  { label: "가품", value: 3 },
  { label: "정품", value: 4 },
  { label: "감정 불가", value: 5 },
  { label: "미흡", value: 6 },
];
export const PARTS = [
  { label: "TC label", value: 1 },
  { label: "leather label", value: 2 },
  { label: "rivet", value: 3 },
  { label: "zipper", value: 4 },
  { label: "lock", value: 5 },
  { label: "stich", value: 6 },
  { label: "front", value: 7 },
  { label: "back", value: 8 },
];
export const IMAGE_GUIDE = [
  { label: "적절하지 않는 확장자", value: 1 },
  { label: "이미지 용량 초과", value: 2 },
  { label: "손상된 이미지", value: 3 },
  { label: "식별 코드 불일치", value: 4 },
  { label: "저해상도 이미지", value: 5 },
  { label: "과한 빛 노출로 인한 식별 불가 이미지", value: 6 },
  { label: "과한 그림자로 인한 식별 불가 이미지", value: 7 },
  { label: "기타", value: 8 },
];
export const IMAGE_GUIDE_STATUS = [
  { label: "관리자 감별 대기중", value: 1 },
  { label: "이미지 반려", value: 2 },
  { label: "이미지 가이드 통과", value: 3 },
];
export const AIAPPRAISAL_STATUS = [
  { label: "감정 신청", value: 1 },
  { label: "감정 진행중", value: 2 },
  { label: "가품", value: 3 },
  { label: "정품", value: 4 },
  { label: "감정 불가", value: 5 },
  { label: "미흡", value: 6 },
];
